import colors from 'styles/colors.json'

const PendingTemplate = (
  <div style={{ height: "100vh", width: "100vw", backgroundColor: colors['color-blue'] }} className="flex-center">
    <img style={{ width: "100%" }} src={ require('images/gifs/live-chat.gif') } />
  </div>
)

export default PendingTemplate


// WEBPACK FOOTER //
// ./src/scripts/components/MobileLander/PendingTemplate.js